module.exports = __webpack_public_path__ + "img/pos_chuong_trinh.9ff9a843.png";